module.exports = __webpack_public_path__ + "img/cabinet_on.c99c158b.svg";